<template>
  <section id="conference">
    <div class="conference__image-container">
      <img src="../../assets/images/lecture.jpg" class="conference__image conference__image--1" />
      <img src="../../assets/images/press.jpg" class="conference__image conference__image--2" />
      <img src="../../assets/images/flytalks.jpg" class="conference__image conference__image--3" />
      <img src="../../assets/images/venue.jpg" class="conference__image conference__image--4" />
      <!-- <img src="../../assets/icons/arrow-white.svg" class="conference__arrow" /> -->
    </div>
    <div class="conference__text">
      <h2 class="conference__title">Dev, Dizajn, Marketing & Tech konferencija</h2>
      <p class="conference__description">
        DUMP Days konferencija se nakon godine stanke vraća u novom formatu! Kao i do sada, najutjecajniji ljudi
        hrvatske IT scene pričat će o aktualnim temama iz svijeta Deva, Dizajna, Marketinga i Techa. Ne propustite ovu
        jedinstvenu priliku, zavirite u poslovni svijet i saznajte kako započeti svoju karijeru.
      </p>
    </div>
    <img src="../../assets/visuals/ring-5.png" class="conference__visual-1" />
    <img src="../../assets/visuals/ball.png" class="conference__visual-2" />
  </section>
</template>

<script>
import speakerVisual from '../../assets/visuals/speaker.png';
import lectureVisual from '../../assets/visuals/lecture.png';
import boothVisual from '../../assets/visuals/booth.png';
import panelVisual from '../../assets/visuals/panel.png';

export default {
  name: 'Conference',
  methods: {
    handleScroll: function (evt, el) {
      if (window.scrollY > 500) {
        el.setAttribute('style', `opacity: 1; transform: translate(0, 0)`);
      }
    },
  },
  data() {
    return {
      speakerVisual: speakerVisual,
      lectureVisual: lectureVisual,
      boothVisual: boothVisual,
      panelVisual: panelVisual,
    };
  },
};
</script>

<style scoped>
#conference {
  max-width: 375px;
  margin: auto;
  padding: 73px 24px 80px 24px;
  position: relative;
}

.conference__image-container {
  position: relative;
  margin-bottom: 16px;
  z-index: 0;
}

.conference__image {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  border-radius: 30px;
}

.conference__image--1 {
  position: relative;
  z-index: 4;
  animation: slider 20s ease-in-out 0s infinite forwards;
}

.conference__image--2 {
  z-index: 3;
  animation: slider 20s ease-in-out 5s infinite forwards;
}

.conference__image--3 {
  z-index: 2;
  animation: slider 20s ease-in-out 10s infinite forwards;
}

.conference__image--4 {
  z-index: 1;
  animation: slider 20s ease-in-out 15s infinite forwards;
}

@keyframes slider {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  35% {
    opacity: 0;
  }
}

/* .conference__arrow {
  width: 32px;
  height: 32px;
  cursor: pointer;
  position: absolute;
  bottom: -54px;
  right: 0;
} */

.conference__title {
  width: 279px;
  margin-bottom: 16px;
  font-size: 32px;
  line-height: 38px;
  font-weight: 800;
  color: #fff;
}

.conference__description {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #ffffffcc;
}

.conference__visual-1,
.conference__visual-2 {
  display: none;
}

@media screen and (min-width: 1180px) {
  #conference {
    max-width: 1440px;
    padding-left: 205px;
  }

  .conference__image {
    border-radius: 50px;
  }

  .conference__image-container {
    display: flex;
    align-items: flex-end;
    margin-bottom: 64px;
    width: 700px;
    height: 440px;
  }

  /* .conference__arrow {
    width: 64px;
    height: 64px;
    margin-left: 70px;
    position: initial;
  } */

  .conference__text {
    width: 505px;
    margin-left: 325px;
  }

  .conference__title {
    width: auto;
    font-size: 48px;
    line-height: 58px;
  }

  .conference__visual-1 {
    display: inline-block;
    width: 442px;
    height: 442px;
    position: absolute;
    bottom: -85px;
    left: 120px;
    z-index: -1;
  }

  .conference__visual-2 {
    display: inline-block;
    width: 426px;
    height: 426px;
    position: absolute;
    bottom: -225px;
    right: 129px;
    z-index: -1;
  }
}

@media screen and (min-width: 1280px) {
  .conference__image-container {
    width: 760px;
    height: 480px;
  }

  /* .conference__arrow {
    margin-left: 101px;
  } */

  .conference__text {
    margin-left: 420px;
  }
}
</style>
